<template>
  <div class="chart-left-panel">
    <!-- Repeating -->

    <div v-if="colorvalue">
      <div
        v-bind:class="iconclass[index]"
        v-for="(item, index) in colorvalue"
        :key="item"
        class="left-panel__item red-color"
      >
        <div class="icon-hold">
          <svg
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 22 24"
          >
            <path
              class="color"
              d="M11 12a6.16 6.16 0 006.29-6A6.16 6.16 0 0011 0a6.16 6.16 0 00-6.29 6A6.16 6.16 0 0011 12zm4.4 1.5h-.82a8.92 8.92 0 01-7.16 0H6.6A6.46 6.46 0 000 19.8v1.95A2.31 2.31 0 002.36 24h17.28A2.31 2.31 0 0022 21.75V19.8a6.46 6.46 0 00-6.6-6.3z"
              v-bind:fill="item"
            />
          </svg>
        </div>
        <div v-if="index == 0 && step == 6" class="burst-bg">
          <svg
            width="42"
            height="43"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 43l-6.494-12.834L0 28.104l10.493-9.987-2.468-14.11L21 10.67l12.975-6.662-2.482 14.11L42 28.104l-14.52 2.062L21 43z"
              fill="#FEF74F"
            />
            <path
              d="M21 0l-6.494 12.834L0 14.896l10.493 9.986-2.468 14.11L21 32.331l12.975 6.661-2.482-14.11L42 14.896l-14.52-2.062L21 0z"
              fill="#FEF74F"
            />
          </svg>
        </div>
        <div v-if="colorname" class="content-text">
          <h5>{{ colorname[index] }}</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IconComponent",

  data() {
    return {
      iconclass: ["noblur", "noblur", "noblur", "noblur", "noblur", "noblur"],
      burstclass: null
    };
  },

  watch: {
    step: function(newCount, oldCount) {
      this.addClass();
    }
  },

  props: ["step", "colorvalue", "colorname"],

  computed: {},

  methods: {
    addClass: function() {
      if (this.step == 0) {
        this.iconclass = [
          "noblur",
          "noblur",
          "noblur",
          "noblur",
          "noblur",
          "noblur"
        ];
        this.burstclass = null;
      }
      if (this.step == 1) {
        this.iconclass = [
          "noblur",
          "noblur",
          "noblur",
          "noblur",
          "noblur",
          "noblur"
        ];
        this.burstclass = null;
      }
      if (this.step == 2) {
        this.iconclass = [
          "noblur",
          "noblur",
          "noblur",
          "noblur",
          "noblur",
          "noblur"
        ];
        this.burstclass = null;
      }
      if (this.step == 3) {
        this.iconclass = [
          "noblur",
          "noblur",
          "noblur",
          "blur",
          "noblur",
          "noblur"
        ];
        this.burstclass = null;
      }
      if (this.step == 4) {
        this.iconclass = [
          "noblur",
          "noblur",
          "blur",
          "blur",
          "noblur",
          "noblur"
        ];
        this.burstclass = null;
      }
      if (this.step == 5) {
        this.iconclass = ["noblur", "noblur", "blur", "blur", "noblur", "blur"];
        this.burstclass = null;
      }
      if (this.step == 6) {
        this.iconclass = ["noblur", "blur", "blur", "blur", "noblur", "blur"];
        this.burstclass = "burst";
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/IconComponent.vue